import AttemptBoard from './AttemptBoard';
import Scoreboard from './Scoreboard';
import TeamScoreboard from './TeamScoreboard';
import TimingClockDisplay from './TimingClock';

const displays = [Scoreboard, AttemptBoard, TeamScoreboard, TimingClockDisplay];

export default displays;



// WEBPACK FOOTER //
// ./src/displays/index.js